import React, { useState } from "react";
import { takrarPranaliStatus } from "../utils/axios";
import {
    Card,
    CardContent,
    Typography,
    Button,
    TextField,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Modal,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TopBarStatic from "./TopBarStatic";
import backgroundAnimationData from '../images/logo.png';

const SearchComponent = () => {
    const [referenceNo, setReferenceNo] = useState("");
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedAttachment, setSelectedAttachment] = useState(null);

    const handleSearch = async () => {
        try {
            if (!referenceNo) {
                alert("Please enter a Reference No");
                return;
            }
            const response = await takrarPranaliStatus(referenceNo);
            setData(response.data.data);
            setError(null);
        } catch (err) {
            setError("Error fetching data");
            setData(null);
            console.error(err);
        }
    };

    const isImage = (fileUrl) => {
        const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
        return imageExtensions.some((ext) => fileUrl.toLowerCase().endsWith(ext));
    };

    const handleOpenModal = (fileUrl) => {
        setSelectedAttachment(fileUrl);
        setOpenModal(true);
    };

    const renderAttachment = (fileUrl) => {
        if (!fileUrl) return null;

        return (
            <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => handleOpenModal(fileUrl)}
            >
                View Attachment
            </Button>
        );
    };

    return (
        <Box className="ff_baloo" sx={{ width: "90%", marginLeft: "6.5%", marginTop: "6.5%" }}>
            <TopBarStatic />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    mx: "auto",
                    mt: 4,

                }}
            >
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%", mt: "20px" }}>
                    {/* Header Section */}
                    <img
                        src={backgroundAnimationData}
                        alt="Logo"
                        style={{
                            width: window.innerWidth <= 600 ? 40 : 100,
                            marginTop: 8,
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: '1200px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        mb: 4,
                        marginTop: { xs: '24px', sm: '30px' },
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            color: '#000',
                            mb: 2,
                            fontSize: { xs: '24px', sm: '30px', md: '36px', lg: '44px' },
                        }}
                        className="ff_yatra"
                    >
                        महसूल विभाग जिल्हा छत्रपती संभाजीनगर
                    </Typography>
                </Box>
                <Box display="flex" gap={2} alignItems="center" width="100%" justifyContent="center">
                    {/* ✅ Search Input Field */}
                    <TextField
                        label="Enter Reference No"
                        variant="outlined"
                        value={referenceNo}
                        onChange={(e) => setReferenceNo(e.target.value)}
                        sx={{
                            marginTop: { xs: "50px", sm: "50px", md: "50px" },
                            width: { xs: "60%", sm: "60%", md: "55%" }, // Responsive width
                            "& .MuiOutlinedInput-root": {
                                height: { xs: 50, sm: 50 },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#4A00E0",
                                },
                            },
                            "& label.Mui-focused": {
                                color: "#4A00E0",
                            },
                        }}
                    />

                    {/* ✅ Search Button */}
                    <Button
                        onClick={handleSearch}
                        variant="contained"
                        color="primary"
                        sx={{
                            marginTop: { xs: "50px", sm: "50px", md: "50px" },
                            height: { xs: 48, sm: 48 }, // Responsive height
                            width: { xs: "25%", sm: "25%", md: "15%" }, // Responsive width
                            background: "linear-gradient(90deg, #8E2DE2 0%, #4A00E0 100%)",
                            "&:hover": {
                                background: "linear-gradient(90deg, #4A00E0 0%, #8E2DE2 100%)",
                            },
                            fontSize: { xs: 14, sm: 16 }, // Responsive font size
                        }}
                    >
                        Search
                    </Button>
                </Box>

                {/* ✅ Error Handling */}
                {error && (
                    <Typography color="error" variant="body1" sx={{ fontSize: 16 }}>
                        {error}
                    </Typography>
                )}

                {/* ✅ Table for Displaying Results */}
                {data && (
                    <Card sx={{ mt: 2, boxShadow: 1 }}>
                        <CardContent>
                            <TableContainer component={Paper}>
                                <Table sx={{ border: "1px solid #ccc" }}>
                                    <TableHead>
                                        <TableRow>
                                            {["Reference No", "Name", "Takrar", "Reply", "Status", "Date", "Attachments"].map(
                                                (header) => (
                                                    <TableCell
                                                        key={header}
                                                        sx={{
                                                            fontWeight: "bold",
                                                            backgroundColor: "#F5F5F5",
                                                            color: "#333",
                                                            textAlign: "center",
                                                            border: "1px solid #ccc", // ✅ Added border to table header
                                                        }}
                                                    >
                                                        {header}
                                                    </TableCell>
                                                )
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                align="center"
                                                sx={{ border: "1px solid #ccc" }} // ✅ Added border to table cells
                                            >
                                                {data.reference_no || "N/A"}
                                            </TableCell>
                                            <TableCell align="center" sx={{ border: "1px solid #ccc" }}>
                                                {data.name || "N/A"}
                                            </TableCell>
                                            <TableCell align="center" sx={{ border: "1px solid #ccc" }}>
                                                {data.takrar || "N/A"}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                sx={{
                                                    backgroundColor: "#FFF3CD",
                                                    fontWeight: "bold",
                                                    border: "1px solid #ccc",
                                                }}
                                            >
                                                {data.reply || "N/A"}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                sx={{
                                                    color: data.status === "1" ? "orange" : "green",
                                                    fontWeight: "bold",
                                                    border: "1px solid #ccc",
                                                }}
                                            >
                                                {data.status === "1" ? "Pending" : "Close"}
                                            </TableCell>
                                            <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                                {new Date(data.created_at).toLocaleDateString("en-IN", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                })}
                                                <br />
                                                {new Date(data.created_at).toLocaleTimeString("en-IN", {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    second: "2-digit",
                                                    hour12: true,
                                                })}
                                            </TableCell>
                                            <TableCell align="center" sx={{ border: "1px solid #ccc" }}>
                                                {data.status === "2" ? (
                                                    <>
                                                        {data.attachment_file && (
                                                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: "bold",
                                                                        color: "#555",
                                                                        mb: 0.5,
                                                                    }}
                                                                >
                                                                    Attachment:
                                                                </Typography>
                                                                {renderAttachment(data.attachment_file)}
                                                            </Box>
                                                        )}

                                                        {data.attachment_file && data.reply_attachment && (
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    color: "#555",
                                                                    fontWeight: "bold",
                                                                    mt: 1,
                                                                    mb: 0.5,
                                                                }}
                                                            >
                                                                Reply Attachment:
                                                            </Typography>
                                                        )}

                                                        {data.reply_attachment && (
                                                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                                {renderAttachment(data.reply_attachment)}
                                                            </Box>
                                                        )}
                                                    </>
                                                ) : (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontStyle: "italic", color: "#777" }}
                                                    >
                                                        N/A
                                                    </Typography>
                                                )}
                                            </TableCell>

                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                )}

                {/* ✅ Modal for Attachments */}
                <Modal open={openModal} onClose={() => setOpenModal(false)}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: { xs: "90%", sm: "80%", md: "60%" },
                            bgcolor: "white",
                            p: 3,
                            borderRadius: "12px",
                        }}
                    >
                        <IconButton
                            onClick={() => setOpenModal(false)}
                            sx={{ position: "absolute", top: 8, right: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                        {selectedAttachment && isImage(selectedAttachment) ? (
                            <img
                                src={`https://telelawmh.in/laravel/public/${selectedAttachment}`}
                                alt="Attachment"
                                style={{
                                    width: "100%",
                                    maxHeight: "500px",
                                    objectFit: "contain",
                                    borderRadius: "8px",
                                }}
                            />
                        ) : (
                            <iframe
                                src={`https://telelawmh.in/laravel/public/${selectedAttachment}`}
                                title="Attachment"
                                width="100%"
                                height="500px"
                                style={{ borderRadius: "8px" }}
                            />
                        )}
                    </Box>
                </Modal>
            </Box>
        </Box>
    );
};

export default SearchComponent;
